import { getShortDate } from './get-short-date';

type TagVariants = 'disabled' | 'success' | 'alert' | 'error';

export type StatusVariants = {
  tagVariant: TagVariants;
  tagText: string;
  subTitleText: string;
};

export const getOrderStatus = ({
  status,
  dateTime,
}: {
  status: string;
  dateTime: string;
}): StatusVariants => {
  const deliveryDate = getShortDate(dateTime);

  const variants: { [key: string]: StatusVariants } = {
    approved: {
      tagVariant: 'disabled',
      tagText: 'Aprovado',
      subTitleText: deliveryDate ? `Previsão de entrega em ${deliveryDate}` : '',
    },
    processing: {
      tagVariant: 'disabled',
      tagText: 'Aprovado',
      subTitleText: deliveryDate ? `Previsão de entrega em ${deliveryDate}` : '',
    },
    delivered: {
      tagVariant: 'success',
      tagText: 'Entregue',
      subTitleText: deliveryDate ? `Entregue em ${deliveryDate}` : '',
    },
    delivering: {
      tagVariant: 'disabled',
      tagText: 'Transporte',
      subTitleText: deliveryDate ? `Previsão de entrega em ${deliveryDate}` : '',
    },
    inProgress: {
      tagVariant: 'disabled',
      tagText: 'Realizado',
      subTitleText: 'Pedido realizado',
    },
    capture: {
      tagVariant: 'disabled',
      tagText: 'Realizado',
      subTitleText: 'Pedido realizado',
    },
    paymentProcess: {
      tagVariant: 'alert',
      tagText: 'Pagamento',
      subTitleText: 'Aguardando a confirmação do pagamento do boleto ou cartão de crédito',
    },
    pending: {
      tagVariant: 'alert',
      tagText: 'Pagamento',
      subTitleText: 'Aguardando a confirmação do pagamento do boleto ou cartão de crédito',
    },
    picking: {
      tagVariant: 'disabled',
      tagText: 'Separação',
      subTitleText: deliveryDate ? `Previsão de entrega em ${deliveryDate}` : '',
    },
    stockLocked: {
      tagVariant: 'disabled',
      tagText: 'Separação',
      subTitleText: deliveryDate ? `Previsão de entrega em ${deliveryDate}` : '',
    },
    transport: {
      tagVariant: 'disabled',
      tagText: 'Transporte',
      subTitleText: deliveryDate ? `Previsão de entrega em ${deliveryDate}` : '',
    },
    canceled: {
      tagVariant: 'error',
      tagText: 'Cancelado',
      subTitleText:
        'Seu pedido pode ser cancelado por vários motivos como: pendência de pagamento, por sua solicitação, prazo de retirada expirado, entre outros.',
    },
  };

  return variants[status] || variants['inProgress'];
};
